<template>
    <div>
        <div class="fixed-bg-overlay"></div>
        <div class="bg-blur" :style="{backgroundImage: 'url(' + require('@/assets/img/base/bg-blur.jpg') + ')'}"></div>

        <v-navigation-drawer
                v-model="filters"
                absolute
                temporary
                touchless
        >
            <div class="pa-2">

                <v-flex pa-3 mt-3>
                    <h3 class="font-weight-regular mb-1">Agregar filtros</h3>
                    <v-divider></v-divider>
                </v-flex>

                <v-flex xs12 pl-3 pr-3>
                    <v-subheader class="pl-0">Especialidad</v-subheader>

                    <service-picker
                            ref="specialtySelector"
                            v-on:change="onSpecialtyChange"
                            multiple
                    ></service-picker>

                </v-flex>

                <v-flex xs12 pl-4 pr-4>
                    <v-subheader class="pl-0">Reputación</v-subheader>
                    <v-range-slider
                            :value="[1, 5]"
                            :thumb-size="24"
                            thumb-label="always"
                            v-model="reputationFilter"
                            always-dirty
                            min="1"
                            max="5"
                            ticks="always"
                    >
                        <template v-slot:thumb-label="props">
                          <span>
                            {{ props.value }}
                          </span>
                        </template>
                    </v-range-slider>
                </v-flex>

                <v-divider></v-divider>

                <v-flex text-center mt-3>
                    <v-btn
                            :disabled="!hasFilters"
                            @click="clearAllFilters"
                            small
                            rounded
                            outlined
                            color="accent"
                    >
                        <v-icon class="mr-1" small>clear</v-icon>
                        Quitar filtros
                    </v-btn>
                    <v-btn
                            :disabled="!filtersWereChanged"
                            @click="applyFilters"
                            small
                            rounded
                            outlined
                            color="primary"
                    >
                        <v-icon class="mr-1" small>check</v-icon>
                        Aplicar
                    </v-btn>
                </v-flex>

            </div>


        </v-navigation-drawer>

        <v-container>
            <v-layout wrap justify-center align-start v-scroll="onScroll">
                <v-flex xs12>
                    <w-main-title title="Servicios" :breadcrumbs="breadcrumbs"></w-main-title>
                </v-flex>

                <v-flex md4 xl3 pa-2>
                    <v-layout class="hidden-sm-and-down" wrap justify-start align-start>

                        <v-flex pa-3 >
                            <h3 class="font-weight-regular mb-2">Agregar filtros</h3>
                            <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 pl-3 pr-3>
                            <v-subheader class="pl-0">Especialidad</v-subheader>

                            <service-picker
                                    ref="specialtySelector"
                                    v-on:change="onSpecialtyChange"
                                    multiple
                            ></service-picker>

                        </v-flex>

                        <v-flex xs12 pl-4 pr-4>
                            <v-subheader class="pl-0">Reputación</v-subheader>
                            <v-range-slider
                                    :value="[1, 5]"
                                    :thumb-size="24"
                                    thumb-label="always"
                                    v-model="reputationFilter"
                                    always-dirty
                                    min="1"
                                    max="5"
                                    ticks="always"
                            >
                                <template v-slot:thumb-label="props">
                          <span>
                            {{ props.value }}
                          </span>
                                </template>
                            </v-range-slider>
                        </v-flex>

                        <v-divider></v-divider>

                        <v-flex text-center mt-3>
                            <v-btn
                                    :disabled="!hasFilters"
                                    @click="clearAllFilters"
                                    small
                                    rounded
                                    outlined
                                    color="accent"
                            >
                                <v-icon class="mr-1" small>clear</v-icon>
                                Quitar filtros
                            </v-btn>
                            <v-btn
                                     :disabled="!hasFilters"
                                    @click="applyFilters"
                                    small
                                    rounded
                                    outlined
                                    color="primary"
                            >
                                <v-icon class="mr-1" small>check</v-icon>
                                Aplicar
                            </v-btn>
                        </v-flex>

                    </v-layout>
                </v-flex>

                <v-flex xs12  md8 xl9 text-center pa-2>
                    <v-layout wrap align-center justify-center>

                        <v-flex xs12 text-center>
                            <div>
                                <v-text-field
                                        class="hidden-sm-and-down ma-2"
                                        hide-details
                                        height="50"
                                        append-icon="search"
                                        outlined
                                        v-model="search"
                                        label="Búsqueda rápida"
                                        placeholder="Institucion / Centro"
                                        clearable
                                        @keyup.enter="applyFilters"
                                        @click:clear="clearSearch"
                                        @click:append="applyFilters"
                                ></v-text-field>
                                <v-text-field
                                        class="hidden-md-and-up ma-2"
                                        hide-details
                                        height="50"
                                        prepend-inner-icon="search"
                                        append-outer-icon="fa-filter"
                                        outlined
                                        v-model="search"
                                        label="Búsqueda rápida"
                                        placeholder="Institucion / Centro"
                                        clearable
                                        @keyup.enter="applyFilters"
                                        @click:clear="clearSearch"
                                        @click:append-outer="showFilters"
                                ></v-text-field>
                            </div>
                        </v-flex>

                        <v-flex xs12 text-center>
                            <div class="text-center flex-center">
                                <v-radio-group height="15" v-model="typeFilter" row>
                                    <v-radio color="accent" label="Todo" value="" checked></v-radio>
                                    <v-radio color="accent" label="Centros" value="institutions"></v-radio>
                                    <v-radio color="accent" label="Especialistas" value="specialists"></v-radio>
                                </v-radio-group>
                            </div>

                        </v-flex>

                        <v-flex xs12 text-center>
                            <v-sheet color="transparent" height="30">
                                <v-chip
                                        v-model="communeChip"
                                        color="primary"
                                        hover
                                        dark
                                        close
                                >Comuna: {{communeFilter.length > 0 ? communeFilter[0].name : ''}}
                                    {{communeFilter.length > 1 ? '(' + (communeFilter.length-1).toString() + '+)' : ''}}
                                </v-chip>
                                <v-chip
                                        v-model="reputationChip"
                                        color="primary"
                                        hover
                                        dark
                                        close
                                >Reputación: {{reputationFilter[0] + '-' + reputationFilter[1]}}
                                </v-chip>
                                <v-chip
                                        v-model="specialtyChip"
                                        color="primary"
                                        hover
                                        dark
                                        close>
                                    Especialidad: {{specialtyFilter.length > 0 ? specialtyFilter[0].name : ''}}
                                    {{specialtyFilter.length > 1 ? '(' + (specialtyFilter.length-1).toString() + '+)' :
                                    ''}}
                                </v-chip>
                            </v-sheet>
                        </v-flex>

                    </v-layout>

                    <v-layout wrap justify-center align-center>
                        <v-flex xs12 pa-4 text-center v-if="loading && !items.length">
                            <v-progress-circular
                                    width="2"
                                    indeterminate
                                    color="primary"
                                    size="70"
                                    class="mt-4"
                            ></v-progress-circular>
                        </v-flex>

                        <v-flex xs12 pa-4 text-center v-if="noResults" class="mt-4">
                        <span class="font-weight-regular">
                            No se encontraron coincidencias.
                        </span>
                            <v-icon>far fa-frown</v-icon>
                        </v-flex>

                        <v-flex xs12 mt-3>
                            <div v-for="(item, i) in items" :key="i" class="specialist-wrapper mt-1">
                                <provider-list-item @click="goToAccount" :item="item"></provider-list-item>
                                <v-btn v-if="currentUser && currentUser.super" class="account-btn" fab small color="accent" @click="showProviderAccount(item.id)">
                                    <v-icon size="14">fas fa-users-cog</v-icon>
                                </v-btn>
                            </div>
                        </v-flex>
                        <v-flex xs12 pa-4 text-center v-if="!loading && moreItemsLink && items.length">
                            <v-sheet height="80" color="transparent">
                                <v-btn
                                        depressed
                                        rounded
                                        text
                                        large
                                        color="black"
                                        :disabled="loading"
                                        @click="getMoreSpecialists"
                                >
                                    Cargar mas
                                </v-btn>
                                <v-flex xs12>
                                    <v-icon>fas fa-chevron-down</v-icon>
                                </v-flex>
                            </v-sheet>
                        </v-flex>
                        <v-flex xs12 pa-4 text-center v-if="loading && items.length">
                            <v-sheet height="80" color="transparent">
                                <v-progress-circular
                                        width="2"
                                        indeterminate
                                        color="primary"
                                        size="30"
                                        class="mt-4"
                                ></v-progress-circular>
                            </v-sheet>
                        </v-flex>
                    </v-layout>

                </v-flex>


            </v-layout>

        </v-container>

        <provider-subscription ref="subscriptionForm"></provider-subscription>

    </div>

</template>

<script>
    import WMainTitle from '@/components/common/WMainTitle'
    import ProviderListItem from '@/components/providers/ProviderListItem'
    import ServicePicker from '@/components/providers/ServicePicker'
    import ProviderSubscription from '@/components/providers/ProviderSubscription'

    import {debounce} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'

    import {mapState, mapMutations} from 'vuex'

    export default{
        components: {
            WMainTitle,
            ProviderListItem,
            ServicePicker,
            ProviderSubscription
        },
        created(){
           this.checkFiltersShowByQuery()
        },
        mounted(){
            var vm = this
            vm.checkFiltersShowByQuery()
            vm.fillFiltersFromQuery()
            vm.$nextTick(function(){
                //vm.debounceGetProviders()
            })
        },
        updated(){
            //this.checkFiltersShowByQuery()
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            goToAccount(provider){
                  const vm = this
              vm.$router.push({
                name: 'panel.super.account.info',
                params: {
                  id: provider.id
                }
              })
            },
            showProviderAccount(id){
                this.$refs.subscriptionForm.showDialog(id)
            },
            setFiltersWereChanged(){
                var vm = this
                if(vm.filters){
                    vm.filtersWereChanged = true
                }

            },
            fillFiltersFromQuery(){

                var vm = this
                const query = vm.$route.query

                if(Object.keys(query).length == 0){
                    vm.getProviders()
                    return
                }

                if(query.commune){
                    vm.communeFilter = query.commune.split(',')
                }

                if(query.specialty){
                    vm.specialtyFilter = query.specialty.split(',')
                }

                if(query.reputation){
                    var reputation = query.reputation.split(',')
                    vm.reputationFilter = reputation.length < 2 ? [1,5] : [reputation[0], reputation[1]]
                }

                if(query.name){
                    vm.search = query.name
                }


            },
            checkFiltersShowByQuery(){
                var vm = this
                if(vm.$route.query.show_filters && vm.$route.query.show_filters == 'true'){
                    vm.showFilters()
                }
            },
            clearAllFilters(){
                var vm = this
                this.$refs.specialtySelector.clear()
                vm.reputationFilter = [1, 5]
            },
            debounceApplyFilter: debounce(function(showDrawer = false){
                this.applyFilters(showDrawer)
            }, 500),
            debounceGetProviders: debounce(function(){
                this.getProviders()
            }, 500),
            applyFilters(showDrawer = false){

                var vm = this

                vm.items = []
                vm.moreItemsLink = null

                var filters = {
                    specialty: vm.specialtyFilter.map(s => s.id).join(','),
                    commune: vm.communeFilter.map(s => s.id).join(','),
                    reputation: vm.reputationFilter.join(','),
                    name: vm.search,
                    show_filters: showDrawer,
                    only: vm.typeFilter
                }

                vm.filtersWereChanged = false

                vm.$router.push({
                    query: filters
                })

                vm.$nextTick(function(){
                    vm.getProviders()
                })

            },
            onScroll(evt){

                return

                var vm = this

                const el = evt.target.getElementsByTagName('html')[0]
                const scrollVal = el.scrollTop
                const height = el.offsetHeight

                if(scrollVal >= (height - 1500) && vm.moreItemsLink){
                    vm.getMoreSpecialists()
                }

                if (scrollVal >= 196) {
                    this.stickyFilters = true
                    return
                }

                this.stickyFilters = false

            },
            showFilters(){
                this.filters = true
            },
            clearSearch(){
                this.search = ''
                this.applyFilters()
            },
            async getProviders(url = ''){
                var vm = this
                vm.noResults = false

               var filters = {
                   service_items: vm.specialtyFilter.map(specialty=>specialty.id).join(','),
                   with_ratings: 1,
                   with_service_item: 1,
                   name: vm.search,
                   reputation: vm.reputationFilter.join(','),
                   communes: vm.communeFilter.map(commune => commune.id).join(','),
                   only: vm.typeFilter
               }
                vm.loading = true
                const response = url ? await ApiUtils.makeGet(url) :
                        await ApiUtils.makeGet('public/providers', filters)
                vm.loading = false

                if (!response.ok) {
                    vm.showSnackBar('Error intentando cargar proveedores')
                    return
                }

                const json = await response.json()
                vm.items = vm.items.concat(json.result.providers.data)
                vm.moreItemsLink = json.result.providers.next_page_url

            },
            getMoreSpecialists(){
                var vm = this
                if(!vm.moreItemsLink) return
                vm.getProviders(vm.moreItemsLink)

            },
            onSpecialtyChange(specialty){
                this.specialtyFilter = specialty;
            },
            onCommuneChange(commune){
                this.communeFilter = commune
            }
        },
        data(){
            return {

                filtersWereChanged: false,

                search: '',
                filters: false,
                loading: true,

                noResults: false,

                communeChip: false,
                specialtyChip: false,
                reputationChip: false,

                communeFilter: [],
                specialtyFilter: [],
                reputationFilter: [1, 5],
                typeFilter: '',

                stickyFilters: false,

                items: [],
                moreItemsLink: null,
                breadcrumbs: [
                    {
                        text: 'Inicio',
                        disabled: false,
                        to: '/'
                    },
                    {
                        text: 'Servicios',
                        disabled: true,
                        href: ''
                    },
                ]
            }
        },
        watch: {
            filters(val){
              if(!val && this.filtersWereChanged){
                  this.applyFilters()
              }
            },
            search(val){
                if(this.search && this.search.length < 3) return
                //this.debounceApplyFilter()
            },
            typeFilter(val){
                var vm = this
                this.debounceApplyFilter()
            },
            communeFilter(val){
                var vm = this
                vm.communeChip = val.length > 0
                vm.setFiltersWereChanged()
            },
            specialtyFilter(val){
                var vm = this
                vm.specialtyChip = val.length > 0
                vm.setFiltersWereChanged()
            },
            reputationFilter(val){
                var vm = this
                vm.reputationChip = !(val[0] === 1 && val[1] === 5)
                vm.setFiltersWereChanged()
            },


            communeChip(val){
                if (!val) {
                    this.$refs.communeSelector.clear()
                    this.debounceApplyFilter()
                }
            },
            specialtyChip(val){
                if (!val) {
                    this.$refs.specialtySelector.clear()
                    this.debounceApplyFilter()
                }
            },
            reputationChip(val){
                if (!val) {
                    this.reputationFilter = [1, 5]
                    this.debounceApplyFilter()
                }
            },
            items(value){
                var vm = this
                if(!value || !value.length){
                    vm.noResults = true
                }else{
                    vm.noResults = false
                }
            }

        },
        computed: {
            ...mapState([
                'currentUser',
                'userDataComplete',
                'institutionDataComplete',
                'regions'
            ]),
            hasFilters(){
                var vm = this
                return vm.communeFilter.length > 0 ||
                        vm.specialtyFilter.length > 0 ||
                        vm.reputationFilter[0] !== 1 ||
                        vm.reputationFilter[1] !== 5
            }
        }
    }
</script>

<style scoped>

    .account-btn{
        position: absolute;
        left: 60px;
        top: 80px;
        width: 35px;
        height: 35px;
        font-size: 14px;
        z-index: 10;
    }

    .flex-center {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    >>>.sticky-filters {
        position: fixed !important;
        top: 4px;
    }

    .specialist-wrapper {
        position: relative;
        background-color: rgba(255, 255, 255, .7);
        transition: .1s all
    }

    .specialist-wrapper:hover {
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.3);
        transform: scale(1.01)
    }

    .bg-blur {
        background-size: cover;
        background-attachment: fixed;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -2;
        opacity: .7;
    }

    .fixed-bg-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: .95;
        z-index: -1;
        pointer-events: none;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#7db9e8+0,1e5799+36 */
        background: rgb(125, 185, 232); /* Old browsers */
        background: -moz-linear-gradient(top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#7db9e8', endColorstr='#1e5799', GradientType=0); /* IE6-9 */
    }


</style>
